<div class="container history-container">
    <app-appointment-list [appointments]="appointments"></app-appointment-list>
    <button *ngIf="showLoadMore" class="btn btn-primary m-1" (click)="loadNextPage()">Load more</button>   
    <ngb-alert *ngIf="errorMessage" type="danger" [dismissible]="true" (closed)="clearError()">{{errorMessage}}</ngb-alert>         
</div>

